import enLang from "./en/en.json"
import deLang from "./de/de.json"
import hrLang from "./hr/hr.json"

const resources = {
    en: enLang,
    de: deLang,
    hr: hrLang
}

export default resources;